
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'app/auth-core/auth.service';
import { BaseComponent } from 'app/common/components/base.component';
import { ModalService } from 'app/common/services/modal.service';
import { ToastService } from 'app/common/services/toasts.service';
import { iconAdd, iconDownload, iconEdit, iconPublish, iconStore, iconTrash } from 'app/common/utils/icons.utils';
import { Roles, UserProfile } from 'app/models/profile.models';
import { ReceipeDTO, Recipe } from 'app/models/recipe.model';
import { ProfileService } from 'app/services/profile.service';
import { RecipeService } from 'app/services/recipe.service';

@Component({
	selector: 'switch-recipes-page',
	templateUrl: './switch-recipes.page.html',
	styleUrls: ["../user-profile.page.scss", "../recipes.page.scss"]
})

export class SwitchRecipesPage extends BaseComponent implements OnInit {
	pageLoaded = false;
	userProfile: UserProfile;
	recipes: Recipe[] = [];
	selectedRecipe: Recipe = null;
	iconTrash = iconTrash;
	iconSave = iconStore;
	iconDownload = iconDownload;
	iconUpload = iconPublish;
	isAutenticated = false;
	iconAdd = iconAdd;
	iconEdit = iconEdit;
	prevRecipeId = null;
	constructor(
		private _userProfileService: ProfileService,
		private _router: Router,
		private _authService: AuthService,
		private _recipeService: RecipeService,
		private _toastService: ToastService,
		private _modalService: ModalService,
		private _translateService: TranslateService) {
		super();
	}

	
	isRecipeEditor = () => {
		if (this.userProfile) return this.userProfile.isInRole(Roles.RECIPE_EDITOR);
		return false;
	}
	updateRecipes = () => {
		this.selectedRecipe = null;
		this._recipeService.getSwitchRecipes().subscribe((res) => {
			
			this.recipes = (res || []).sortAsc(r => r.envScoreClass);

			if (this.recipes && this.recipes.length > 0) {
				if (this.prevRecipeId) {
					this.recipes.forEach((r) => {
						if (r.id == this.prevRecipeId) this.selectedRecipe = r;
					})
					if (!this.selectedRecipe) this.selectedRecipe = this.recipes[0];
					this.prevRecipeId = null;
				}
				else {
					this.selectedRecipe = this.recipes[0];
				}
			}
		})
	}

	ngOnInit() {
		this._userProfileService.loadUserProfile().subscribe((result) => {
			this.updateRecipes();
			this.on(
				this._authService.isAuthenticated$.subscribe((isAutenticated) => {
					this.isAutenticated = isAutenticated;
				})
			)
			this.userProfile = result;
			this.pageLoaded = true;
	
		})
	}
	get canSave() {
		return this.selectedRecipe && this.selectedRecipe.recipeName?.length > 0 && this.selectedRecipe.servings > 0 && this.selectedRecipe.ingrediants?.length > 0;
	}

	selectRecipe = (recipe) => {
		this._router.navigate(["recipes", "switch-recipe",""+recipe.id]);
	}

	get canRemove () {
		return false;
	}

	removeRecipe = (recipe: Recipe) => {
		if (recipe) {
			let callback = (data) => {
				if (data) {
					this._recipeService.delete(recipe.id).subscribe((result) => {
						this.updateRecipes();
					})
				}
			}
			this._modalService.showConfirm("common.dialogs.alertRemoveItemTitle", "common.dialogs.alertRemoveItemMessage", {
				callback: callback,
				size: "md"
			});	
		}
	}
	removeSelected = () => {
		// if (this.selectedRecipe && this.selectedRecipe.id) {
		// 	this._recipeService.deleteSwitchRecipe(this.selectedRecipe.id).subscribe((result) => {
		// 		this.updateRecipes();
		// 	})
		// }
		
	}
	downloadSelected = () => {
		if (this.selectedRecipe) {
			let dto: ReceipeDTO = this._recipeService.fromRecipeToDTO(this.selectedRecipe);
			dto.id = null;
			const blob = new Blob([JSON.stringify(dto)], { type: 'text/json' });
	  
			// Create a link to the blob
			const link = document.createElement('a');
			link.href = window.URL.createObjectURL(blob);
			link.download = (dto.recipeName && dto.recipeName.trim())? dto.recipeName.trim() + ".switch": 'recipt.switch';
			link.click();
			this._toastService.showSuccess(this._translateService.instant("recipePage.downloadReceiptMessage"));
		}
	}
	storeSelected = () => {
		this.prevRecipeId = this.selectedRecipe.id;
		this._recipeService.saveOrUpdateSwitchRecipe(this.selectedRecipe).subscribe((result) => {
			this._toastService.showSuccess(this._translateService.instant("recipePage.receipeSavedMessage"));
			this.updateRecipes();
		})
	}

	newRecipe = () => {
		this._router.navigate(["recipes", "switch-recipe"]);


		
	}

	@ViewChild('fileInput') fileInput: ElementRef;
	
	public loadReceipt = () => {		
		this.fileInput.nativeElement.click();
	}
	// public fileChanged = (e) => {
	// 	console.log("e: ", e);
		
	// 	let file = e.target.files[0];
	// 	let fileReader = new FileReader();
	// 	fileReader.onload = (load) => {
	// 		try {
	// 			let dto: ReceipeDTO = JSON.parse(""+fileReader.result);
	// 			this.selectedRecipe = this._recipeService.fromDTOToRecipe(dto);
	// 			this._toastService.showSuccess(this._translateService.instant("recipePage.loadReciptSuccess"));
	// 			this.fileInput.nativeElement.value = null;
	// 		} catch (error) {
	// 			this._toastService.showDanger(this._translateService.instant("recipePage.loadReciptError"));
	// 		}
	// 	}
	// 	if (file)
	// 		fileReader.readAsText(file);
	// }
		public fileChanged = (e) => {
		
		let file = e.target.files[0];
		let fileReader = new FileReader();
		fileReader.onload = (load) => {
			try {
				let dto: ReceipeDTO = JSON.parse(""+fileReader.result);
				let selectedRecipe = this._recipeService.fromDTOToRecipe(dto);
				this._recipeService.saveOrUpdateSwitchRecipe(selectedRecipe).subscribe((result) => {
					this._toastService.showSuccess(this._translateService.instant("recipePage.loadReciptSuccess"));
					this.fileInput.nativeElement.value = null;
					this.updateRecipes();
				})
				
			} catch (error) {
				this._toastService.showDanger(this._translateService.instant("recipePage.loadReciptError"));
			}
		}
		if (file)
			fileReader.readAsText(file);
	}
}